import React from 'react';
import PropTypes from 'prop-types';
import styles from './SegmentedControl.module.scss';

const SegmentedControl = ({
  value,
  options,
  onChange,
  label,
  className,
}) => {
  const selectedIndex = Math.max(0, options.findIndex((option) => option.value === value));
  const rootClassName = [styles.root, className].filter(Boolean).join(' ');

  return (
    <div
      className={rootClassName}
      role="group"
      aria-label={label}
      style={{ gridTemplateColumns: `repeat(${options.length}, minmax(0, 1fr))` }}
    >
      <span
        className={styles.indicator}
        aria-hidden="true"
        data-segmented-indicator=""
        style={{
          width: `calc((100% - 6px) / ${options.length})`,
          transform: `translate3d(${selectedIndex * 100}%, 0, 0)`,
        }}
      />
      {options.map((option) => {
        const selected = option.value === value;

        return (
          <button
            key={option.value}
            type="button"
            value={option.value}
            className={styles.option}
            aria-label={option.ariaLabel}
            aria-pressed={selected}
            disabled={option.disabled}
            onClick={() => {
              if (!selected) onChange(option.value);
            }}
          >
            {option.icon && <span className={styles.icon} aria-hidden="true">{option.icon}</span>}
            <span className={styles.label}>{option.label}</span>
          </button>
        );
      })}
    </div>
  );
};

SegmentedControl.propTypes = {
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
    ariaLabel: PropTypes.string,
    icon: PropTypes.node,
    disabled: PropTypes.bool,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

SegmentedControl.defaultProps = {
  className: null,
};

export default SegmentedControl;
